import * as React from 'react';
import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import { StatusIndicator } from '@vcd-ecm-ui/Common';
import { dateCompare, stringCompare } from '@vcd-ecm-ui/GenericGrid';
import GridRowData from './GridRowData';

const columns: VtxColumnProps<GridRowData>[] = [
  {
    title: 'Template Name',
    dataIndex: 'templateName',
    fixed: 'left',
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.templateName, b.rowData.templateName),
    // filterMultiple: true,
    // onFilter: (value, row: GridRowData) => row.rowData.templateName === value.toString(),
    className: 'correspondenceColumnStyle',
    ellipsis: true,
  },
  {
    title: 'Date Created',
    dataIndex: 'createdDateTime',
    sorter: (a: GridRowData, b: GridRowData) => dateCompare(a.createdDateTime, b.createdDateTime),
    render: (value, row: GridRowData, index: number) => (value ? value.toLocaleDateString() : null),
    // filterMultiple: true,
    // onFilter: (value, row: GridRowData) => row.rowData.createdDateTime === value.toString(),
    width: 200,
  },
  {
    title: 'Author',
    dataIndex: 'author',
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.author, b.rowData.author),
    // filterMultiple: true,
    // onFilter: (value, row: GridRowData) => row.rowData.author === value.toString(),
    className: 'correspondenceColumnStyle',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    sorter: (a: GridRowData, b: GridRowData) => stringCompare(a.rowData.status, b.rowData.status),
    // eslint-disable-next-line react/destructuring-assignment
    render: (value, row: GridRowData, index: number) => <StatusIndicator status={value.toString()} />,
    /*
    filters: [
      {
        text: 'Active',
        value: 'ACTIVE',
      },
      {
        text: 'Inactive',
        value: 'INACTIVE',
      },
    ],
    filterMultiple: true,
    onFilter: (value, row: GridRowData) => row.rowData.status.toString().indexOf(value.toString()) === 0,
    */
    width: 200,
  },
  {
    title: 'Action',
    dataIndex: 'action',
    fixed: 'right',
    width: 150,
  },
];

const getDefaultColumns = (): VtxColumnProps<GridRowData>[] => columns;

export default getDefaultColumns;
